import { FunctionComponent } from "react";
import styles from "../stylesheets/components/trust-you.module.css";
import {
  Language,
  TranslatedPartnerLogo,
  type TrustYou,
} from "../types/index.js";
import { getTranslations } from "../utils/utils.js";
import Icon from "./Icon.js";
import LazyImage from "./LazyImage.js";

interface Props extends TrustYou {
  logo: TranslatedPartnerLogo | undefined;
  languageId: Language;
}

const translations = {
  de: { excellent: "Ausgezeichnet", reviews: "Bewertungen" },
  it: { excellent: "Eccellente", reviews: "recensioni" },
  en: { excellent: "Excellent", reviews: "reviews" },
};

const TrustYou: FunctionComponent<Props> = ({
  logo,
  count,
  value,
  stars,
  languageId,
}) => {
  const i18n = getTranslations(languageId, translations);

  return (
    <section className={styles.TrustYou}>
      <div className={styles.TrustYou__Grade}>{i18n.excellent}</div>
      <div className={styles.TrustYou__Content}>
        <div className={styles.TrustYou__Rating}>{value}</div>
        <div className={styles.TrustYou__Stars}>
          {stars.map((star, index) => (
            <Icon key={index} glyph={star} />
          ))}
        </div>
        <div className={styles.TrustYou__Ratings}>
          {count} {i18n.reviews}
        </div>
        {logo && (
          <div className={styles.TrustYou__Logo}>
            <LazyImage src={logo.translation.url} />
          </div>
        )}
      </div>
    </section>
  );
};

export default TrustYou;
